<template>
    <div :class="mobile ? 'lightblue-section-mobile' : 'lightblue-section section-text'" :style="mobile ? 'padding: 50px 20px; margin-top: 30px;' : 'padding: 70px 50px; margin-top: 60px;'" >
      Send queries to: &#105;&#110;&#102;&#111;&#91;&#97;&#116;&#93;&#101;&#112;&#105;&#119;&#97;&#116;&#99;&#104;&#46;&#111;&#114;&#103;
    </div>

        <!-- <v-form ref="form" v-model="valid">
          <b>First Name*</b>
          <v-text-field v-model="firstName" :rules="nameRules" label="First name *" background-color="white" filled dense outlined required></v-text-field>
          <b>Last Name*</b>
          <v-text-field v-model="lastName" :rules="nameRules" label="Last name *" background-color="white" filled dense outlined required></v-text-field>
          <b>Company Name*</b>
          <v-text-field v-model="companyName" :rules="nameRules" label="Company name *" background-color="white" filled dense outlined required></v-text-field>
          <b>Email*</b>
          <v-text-field v-model="email" :rules="emailRules" label="Email *" background-color="white" filled dense outlined required></v-text-field>
          <b>Message</b>
          <v-textarea v-model="message" :rules="messageRules" label="Message *" counter="120" background-color="white" filled dense outlined required></v-textarea>
          <br/>
          <div style="margin-right: 20px;">
          <vue-recaptcha
          ref="recaptcha"
          @verify="onCaptchaVerified"
          @expired="onCaptchaExpired"
          @error="onCaptchaExpired"
          :sitekey="recaptchaSiteKey"
          >
          </vue-recaptcha>
          </div>
          <br/>
          <span>
          <v-btn x-large class="red-button" :disabled="!submitVerified" @click="submit" style="margin-right: 10px; float: left;">
              Submit Enquiry
          </v-btn>
          <v-alert v-if="emailed" color="#d93b38" style="float: left;" dismissible dense dark height="36px">
            Your email has been received. We will reply back to you soon.
          </v-alert>
          </span>
        </v-form> -->
</template>
<script>
import axios from 'axios'
import config from '../config'
// import VueRecaptcha from 'vue-recaptcha'

 export default {
  name: 'ContactForm',
  components: {
    // VueRecaptcha
  },
  data: () => ({
    recaptchaSiteKey: config.recaptchaSiteKey,
    firstName: "",
    lastName: "",
    companyName: "",
    recaptchaToken: null,
    submitVerified: false,
    mobile: null,
    valid: false,
    emailed: false,

    email: "",
    message: "",
    nameRules: [
      v => (!!v && v.length > 0) || 'Field is required'
    ],
    emailRules: [
      v => !!v || 'Field is required',
      v => (v && v.length > 0 && /.+@.+/.test(v)) || 'Field must be a valid email'
    ],
    messageRules: [
      v => !!v || 'Field is required',
      v => (v && v.length > 0 && v.length <= 120 || 'Maximum limit of 120 characters for message')
    ],
  }),
  watch: {
    valid: function (val) {
      this.submitVerified = !!this.recaptchaToken && val && !this.emailed
    },
    recaptchaToken: function (val) {
      this.submitVerified = !!val && this.valid && !this.emailed
    }
  },
  methods: {
    checkScreen() {
        this.windowWidth = window.innerWidth;
        if (this.windowWidth <= 1000) {
          this.mobile = true;
        } else {
          this.mobile = false;
        }
      
        return;
    },
    onCaptchaVerified(recaptchaToken) {
      this.recaptchaToken = recaptchaToken
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset()
      this.recaptchaToken = null
    },
    submit() {
        const self = this;
        if (self.submitVerified && self.recaptchaToken) {
          self.submitVerified = false
          let bodyObjectToSend = {
              recaptchaToken: self.recaptchaToken,
                email: btoa(self.email),
                firstName: btoa(self.firstName),
                lastName: btoa(self.lastName),
                companyName: btoa(self.companyName),
                message: btoa(self.message)
          }
          

          axios.get(config.api_url + "api/email", bodyObjectToSend).then(() => {
              self.emailed = true
              self.recaptchaToken = null
          })
        }
      }  
  },
}


</script>
